angular.module('capability-ng-scheduler').directive('eabModalDeprecated', function eabModalDeprecated() {
  'use strict';

  return {
    replace: true,
    transclude: true,
    templateUrl: 'capability-ng-scheduler/src/components/modal/modal.html',
    scope: {
      ignoreModalClose: '@', // stop modal from 'closing' when window is clicked
      title: '@'
    },
    controller($scope: any, $rootScope: any, $timeout: any, $state: any) {
      $scope.$on('phoenix.modal.close', () => {
        $scope.exit();
      });

      $scope.exit = () => {
        if (!$scope.ignoreModalClose) {
          $state.go('^');
        }
      };
    },
    link(scope: any, element: any, attrs: any) {
      /*
       * Accessibility Features
       * */
      if (scope.ignoreModalClose) {
        angular.element(element).find('component--modal-underlay').removeAttr('tabindex').removeAttr('role');
      }
      setTimeout(() => {
        angular.element(element).find('.modal').attr('tabindex', -1).focus();

        // why do we need to update the whole application everytime a model is rendered?
        //
        //
        scope.$apply();
      }, 1000);
    }
  };
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/modal/modal.ts